import { action, observable } from 'mobx';
import apiCaller from '../../utils/api-caller';
import { v4 } from 'uuid';

class CmsDiningStore {
  @observable data = [];
  @observable images = [];

  @observable dinings = [];
  @observable dining = null;

  @observable selecteddining = null;
  @observable selectedimages = [];

  @observable showModal = false;
  @observable modalTitle = '';

  @observable updateLoading = false;

  @action getAll() {
    return apiCaller.CmsDinings.get().then(resp => {
      if (!resp.isError) {
        if (resp.data) {
          this.data = resp.data;
        }
      }
    })
  }

  @action getAllByLanguage() {
    const languageCode = window.localStorage.getItem('lang') || 'en';
    return apiCaller.CmsDinings.getByLanguageCode(languageCode).then(resp => {
      if (resp) {
        this.dinings = resp;
      }
    })
  }

  @action getByIdAndLanguage(id) {
    const languageCode = window.localStorage.getItem('lang') || 'en';
    return apiCaller.CmsDinings.getByIdAndLanguageCode(id, languageCode).then(resp => {
      if (resp) {
        this.selecteddining = resp;
        this.selectedimages = [];
        if (this.selecteddining.bannerUrl) {
          try {
            let imagesJson = JSON.parse(this.selecteddining.bannerUrl);
            imagesJson.map(imageJson => {
              return imageJson.isLoading = false;
            });
            this.selectedimages = imagesJson;
          } catch {
            this.selectedimages.push({
              id: v4(),
              url: this.selecteddining.bannerUrl,
              isLoading: false
            });
          }
        }
      }
    })
  }

  @action getDataById(id) {
    this.modalTitle = 'Update Dining';
    return apiCaller.CmsDinings.getById(id).then(resp => {
      if (!resp.isError) {
        if (resp.data) {
          this.images = [];
          this.dining = resp.data;

          if (this.dining.bannerUrl) {
            try {
              let imagesJson = JSON.parse(this.dining.bannerUrl);
              imagesJson.map(imageJson => {
                return imageJson.isLoading = false;
              });
              this.images = imagesJson;
            } catch {
              this.images.push({
                id: v4(),
                url: this.dining.bannerUrl,
                isLoading: false
              });
            }
          }

          this.images.push({
            id: v4(),
            url: '',
            isLoading: false
          });

          this.showModal = true;
        }
      }
    })
  }

  @action initCreate(languages) {
    this.modalTitle = 'Add Dining';
    this.dining = {
      'id': 0,
      'bannerUrl': '',
      'sort': 1,
      'diningLanguages': []
    };

    languages.map(language => {
      this.dining.diningLanguages.push({
        'id': 0,
        'diningId': 0,
        'languageId': language.id,
        'title': '',
        'briefDescription': '',
        'description': ''
      });

      return language;
    })

    this.images = [{
      id: v4(),
      url: '',
      isLoading: false
    }];

    this.showModal = true;
  }

  @action create() {
    this.updateLoading = true;

    this.dining.bannerUrl = JSON.stringify(this.images.filter(fi => fi.url !== ''));
    return apiCaller.CmsDinings.create(this.dining);
  }

  @action update() {
    this.updateLoading = true;

    this.dining.bannerUrl = JSON.stringify(this.images.filter(fi => fi.url !== ''));
    return apiCaller.CmsDinings.update(this.dining.id, this.dining);
  }

  @action delete(id) {
    return apiCaller.CmsDinings.delete(id);
  }

  @action cancel() {
    this.getData();
  }

  @action setsort(value) {
    this.dining.sort = value;
  }

  @action settitle(langId, value) {
    let lang = this.dining.diningLanguages.find(fi => fi.languageId === langId);
    if (lang) {
      lang.title = value;
    }
  }

  @action setbriefDescription(langId, value) {
    let lang = this.dining.diningLanguages.find(fi => fi.languageId === langId);
    if (lang) {
      lang.briefDescription = value;
    }
  }

  @action setdescription(langId, value) {
    let lang = this.dining.diningLanguages.find(fi => fi.languageId === langId);
    if (lang) {
      lang.description = value;
    }
  }

  @action setImageUrlById(id, value) {
    let image = this.images.find(fi => fi.id === id);
    if (image) {
      image.url = value;
    }

    let blankImage = this.images.find(fi => fi.url === '');
    if (!blankImage) {
      this.images.push({
        id: v4(),
        url: '',
        isLoading: false
      });
    }
  }

  @action setImageIsLoadingById(id, isLoading) {
    let image = this.images.find(fi => fi.id === id);
    if (image) {
      image.isLoading = isLoading;
    }
  }

  @action removeImageById(id) {
    this.images = this.images.filter(fi => fi.id !== id);
  }

  @action setdining(value) {
    this.dining = value;
  }

  @action setupdateLoading(value) {
    this.updateLoading = value;
  }

  @action setshowModal(value) {
    this.showModal = value
  }

  @action resetData() {
    this.dining = null;

    this.selecteddining = null;
    this.selectedimages = [];
  }
}

export default new CmsDiningStore();